import { render, staticRenderFns } from "./NoRows.vue?vue&type=template&id=24b14266&scoped=true&"
import script from "./NoRows.vue?vue&type=script&lang=ts&"
export * from "./NoRows.vue?vue&type=script&lang=ts&"
import style0 from "./NoRows.vue?vue&type=style&index=0&id=24b14266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b14266",
  null
  
)

export default component.exports